import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/FirebaseAuthContext';
import { Home, Search, Plus, MessageCircle, User, Settings } from 'lucide-react';

const MobileBottomNav = () => {
  const { isAuthenticated, user, isAdmin } = useAuth();
  const location = useLocation();
  const [hidden, setHidden] = useState(false);

  // Auto-hide on scroll down, reveal on scroll up (OfferUp/Instagram style).
  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY && y > 80) {
        setHidden(true);   // scrolling down past a small threshold
      } else if (y < lastY) {
        setHidden(false);  // scrolling up
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav
      className="mobile-bottom-nav"
      style={{
        // Slide fully off-screen including the 16px bottom gap when hidden.
        transform: hidden ? 'translateY(calc(100% + 24px))' : 'translateY(0)',
        transition: 'transform 0.25s ease',
      }}
    >
      <div className="mobile-nav-items">
        <Link
          to="/"
          className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}
        >
          <Home size={24} />
          <span>Home</span>
        </Link>

        <Link
          to="/?search=true"
          className={`mobile-nav-item ${location.search.includes('search') ? 'active' : ''}`}
        >
          <Search size={24} />
          <span>Search</span>
        </Link>

        <Link
          to="/create-listing"
          className={`mobile-nav-item ${isActive('/create-listing') ? 'active' : ''}`}
        >
          <div style={{
            background: 'var(--primary)',
            borderRadius: '50%',
            padding: '12px',
            marginBottom: '4px'
          }}>
            <Plus size={24} color="white" />
          </div>
          <span>Sell</span>
        </Link>

        <Link
          to="/messages"
          className={`mobile-nav-item ${isActive('/messages') ? 'active' : ''}`}
        >
          <MessageCircle size={24} />
          <span>Messages</span>
        </Link>

        {isAdmin ? (
          <Link
            to="/admin"
            className={`mobile-nav-item ${isActive('/admin') ? 'active' : ''}`}
          >
            <Settings size={24} />
            <span>Admin</span>
          </Link>
        ) : (
          <Link
            to={`/profile/${user?.username}`}
            className={`mobile-nav-item ${location.pathname.includes('/profile') ? 'active' : ''}`}
          >
            <User size={24} />
            <span>Profile</span>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
